// extracted by mini-css-extract-plugin
export var content = "_4k-3";
export var list = "_4k-4";
export var settingsContent = "_4k-7";
export var settingsPanel = "_4k-8";
export var state = "_4k-6";
export var triggerBadge = "_4k-2";
export var triggerButton = "_4k-1";
export var triggerShell = "_4k-0";
export var unreadDot = "_4k-5";